<script lang="ts">
    import BaseSkeleton from "./BaseSkeleton.svelte";

    export let height = "15px";
    export let width = "100%";
    export let gap = "15px";
    export let count = 5;
</script>

<div class="stacked-skeleton" style="--width: {width}; --gap: {gap}">
    {#each new Array(count).fill(null) as _}
        <BaseSkeleton {height} width="100%" />
    {/each}
</div>

<style>
    .stacked-skeleton {
        display: flex;
        flex-direction: column;
        width: clamp(20px, var(--width), var(--width));
        gap: var(--gap);
    }
</style>
